<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="welcome"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">What You Get</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="whatyouget-page">
        <!-- Page Title -->
        <div class="page-title">
            <h1>What You Get With Your Free Trial Period</h1>
        </div>

        <!-- Two Column Layout -->
        <div class="two-column-container">
            <!-- Left Column - Trial Plan Info -->
            <div class="left-column">
                <h3 class="section-title">Trial Period Plan...</h3>
                <hr class="divider" />

                <p class="plan-info"><strong>Plan Price:</strong> $0.00</p>
                <p class="plan-info"><strong>Plan Duration:</strong> 15 Day Free Trial</p>
                <hr class="divider" />

                <h4 class="subsection-title">Challenge Rewards:</h4>
                <ul class="check-list">
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Earn An Extra 15 Days = 30 Days Total</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>An Option To Lock In Your Price</span>
                    </li>
                </ul>
                <hr class="divider" />

                <h4 class="subsection-title">What You Get:</h4>
                <ul class="check-list">
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>30 Day Free Trial</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Total Shuttle Department Efficiency</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Improved Customer Communication</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Generate Revenue</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Live Q &amp; A Webinars</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>60 Day Premium Email &amp; Phone Support</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Free Pilot Program Coaching Call</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>"Guaranteed Success!"</span>
                    </li>
                </ul>
            </div>

            <!-- Right Column - Get Started -->
            <div class="right-column">
                <h3 class="section-title">Let's Get Started...</h3>
                <hr class="divider" />

                <p class="description">
                    Your shuttle department's transformation begins with filling out the application form.
                </p>

                <ion-button data-test="bookCoachingCallButton" class="apply-button" expand="block" color="primary"
                    (click)="onApplyForFreeTrialClick()">
                    Apply Now
                </ion-button>

                <h4 class="subsection-title agenda-title">Coaching Call Agenda:</h4>
                <ul class="check-list agenda-list">
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Interview &amp; Determine If We Can Help</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Application Login &amp; Walkthrough</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Step-By-Step Setup Instructions</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Step-By-Step Ticket Creation</span>
                    </li>
                    <li>
                        <ion-icon name="checkmark-circle" class="check-icon"></ion-icon>
                        <span>Step-By-Step Ticket Processing</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ion-content>
